import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "./DeleteTrainingGroup.css";

function DeleteTrainingGroup() {
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { tid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups/${tid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.trainingGroup.name);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingGroups/${tid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings/training-groups");
    } catch (error) {
      toast(error.response.data.message);
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col className="delete-training-group">
            <Col>
              <h4>
                {t(
                  "Capacitaciones.GruposDeCapacitacion.DeleteTrainingGroup.Titulo"
                )}
              </h4>
            </Col>
            <Col className="delete-training-group-form">
              <Col className="mb-1">
                <p>
                  {t(
                    "Capacitaciones.GruposDeCapacitacion.DeleteTrainingGroup.Pregunta"
                  )}
                </p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t(
                    "Capacitaciones.GruposDeCapacitacion.DeleteTrainingGroup.Eliminar"
                  )}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate("/trainings/training-groups")}
                >
                  {t(
                    "Capacitaciones.GruposDeCapacitacion.DeleteTrainingGroup.Cancelar"
                  )}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteTrainingGroup;
